import { Field, Label, Switch } from "@headlessui/react";
import classNames from "classnames";
import styles from "./ToggleSwitch.module.css";

interface Props {
  name?: string;
  label?: string;
  checked: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  onChange: (checked: boolean) => void;
}

const ToggleSwitch = ({
  name,
  label,
  checked,
  disabled = false,
  fullWidth = false,
  onChange,
}: Props) => {
  return (
    <Field
      className={classNames({
        [styles.fullWidth]: fullWidth,
      })}
    >
      {label && <Label className={styles.label}>{label}</Label>}
      <Switch
        checked={checked}
        onChange={onChange}
        className={classNames(styles.switch, {
          [styles.checked]: checked,
          [styles.disabled]: disabled,
        })}
        disabled={disabled}
        name={name}
      >
        <span
          className={classNames(styles.toggle, {
            [styles.checked]: checked,
          })}
        ></span>
      </Switch>
    </Field>
  );
};

export default ToggleSwitch;
